import React, { useEffect, useState } from "react";
import {
  CgAwards,
  CgClipboard,
  CgFileDocument,
  CgMicrosoft,
  CgPen,
  CgTranscript,
  CgLoadbarDoc,
  CgFile,
  CgFolder,
  CgTrack,
} from "react-icons/cg";
import "./DasboardSidebar.css";

import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../LanguageProvider/LanguageProvider ";
import { GetLocalStorage, GetLocalStorageParsed } from "../../../Utils/Utils";
import { checkApplicationsData, oldDocumentData, getUserDashboardData } from "../../../services/api/user";

const DasboardSidebar = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const [applicationData, setApplicationData] = useState(null);
  const [userDashboardData, setUserDashboardData] = useState(null);
  const [showDraft, setShowDraft] = useState("false");
  const [showTrack, setShowTrack] = useState("false");
  const userDetail = GetLocalStorageParsed("userDetail");
  const getLoginSubCabData = GetLocalStorageParsed("LoginSubCatData");
  const [showOldDocumentsTab, setShowOldDocumentsTab] = useState(false);

  const getApplicationData = async () => {
    const formData = new FormData();
    formData.append("user_id", userDetail?.id);
    const data = await checkApplicationsData(formData);
    checkApplicationStatus(data?.data);
    setApplicationData(data?.data);
    try {
    } catch (err) {
      //console.log(err);
    }
  };

  const fetchOldDocumentData = async () => {
      try {
        const formData = new FormData();
        formData.append("unique_id", userDetail?.unique_id);
        const details = await oldDocumentData(formData);
        if (details && details?.categories && details?.categories.length > 0) {
          setShowOldDocumentsTab(details?.categories?.filter(item => item.files && item.files.length > 0)?.length > 0);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

  const getDashboardData = async () => {
    const data = await getUserDashboardData(userDetail?.id, userDetail?.unique_id);
    setUserDashboardData(data?.data)
    try {
    } catch (err) {
      //console.log(err);
    }
  };

  const checkApplicationStatus = async (data) => {
    const app_id = GetLocalStorage('application_id')
    if (data?.length > 0 && getLoginSubCabData) {
      const filterAppData = data.filter(
        (x) => x.category_id == getLoginSubCabData?.id
      );
      if (location.pathname == "/dashboard") {
        setShowDraft("false");
        setShowTrack("false");
      } else {
        if(app_id != null){
          switch (filterAppData[0]?.status){
            case '2' : {
              setShowTrack("true");
              setShowDraft("true");
            }
            break;
            case '3': {
              setShowTrack("false");
              setShowDraft("true");
            }
              break;
            case '4': {
              setShowTrack("true");
              setShowDraft("false");
            }
              break;
            case '5': {
              setShowTrack("true");
              setShowDraft("true");
            }
              break;
            case '7': {
              setShowTrack("true");
              setShowDraft("false");
            }
             break;
            case '8': {
              setShowTrack("true");
              setShowDraft("false");
            }
              break;
            case '11': {
              setShowTrack("true");
              setShowDraft("true");
            }
              break;
          }
        }else{
          setShowTrack("false");
          setShowDraft("false");
        }
      }
    } else {
      setShowDraft("false");
    }
  };

  useEffect(() => {
    getApplicationData();
    getDashboardData();
    fetchOldDocumentData();
  }, []);

  return (
    <div className="hcat-second-das pb-5">
      <div className="ds-left mt-2">
        <ul className="ds-ul">
          <li onClick={() => navigate("/dashboard")}>
            {/* <button className={pathName==="/guidelines" ?'ds-green' : 'ds-white'} > <CgClipboard />Dashboard <span></span></button> */}
            <button
              className={
                pathName === "/dashboard" || pathName === "/guidelines"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              {" "}
              <CgMicrosoft /> <span>{language ? "डैशबोर्ड" : "Dashboard"}</span>
            </button>
          </li>
          {/* <li onClick={() => navigate("/application/overview")}>
            <button
              className={
                pathName?.split("/")?.[1] === "application"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              {" "}
              <CgClipboard />{" "}
              <span>{language ? "आवेदन फार्म" : "Application Form"}</span>
            </button>
          </li> */}
          {showDraft == "true" ? (
            <li onClick={() => navigate("/application-draft")}>
              {/* <button className={pathName==="/guidelines" ?'ds-green' : 'ds-white'} > <CgClipboard />Dashboard <span></span></button> && checkApplicationStatus(getLoginSubCabData) */}
              <button
                className={
                  pathName === "/application-draft" 
                    ? "bg_image_green"
                    : "bg_image_white"
                }
              >
                {" "}
                <CgPen />
                <span>{language ? "आवेदन ड्राफ्ट" : "Application Draft"}</span>
              </button>
            </li>
          ) : (
            ""
          )}
          {applicationData?.length > 0 ? (
            <li onClick={() => navigate("/applications")}>
              {/* <button className={pathName==="/guidelines" ?'ds-green' : 'ds-white'} > <CgClipboard />Dashboard <span></span></button> */}
              <button
                className={
                  pathName === "/applications"
                    ? "bg_image_green"
                    : "bg_image_white"
                }
              >
                {" "}
                <CgLoadbarDoc />
                <span>{language ? "अनुप्रयोग" : "Applications"}</span>
              </button>
            </li>
          ) : (
            ""
          )}
          {userDashboardData?.certificates && userDashboardData?.certificates > 0 ? <li onClick={() => navigate("/certificate")}>
            <button
              className={
                pathName === "/certificate"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              <CgAwards />{" "}
              <span>{language ? "प्रमाणपत्र" : "Certificates"}</span>
            </button>
          </li> : <></>}
          {userDashboardData?.provisionalCertificates && userDashboardData?.provisionalCertificates > 0 ? <li onClick={() => navigate("/provisional-certificate")}>
            <button
              className={
                pathName === "/provisional-certificate"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              <CgAwards style={{ marginLeft: 6, marginRight: 3 }} />{" "}
              <span style={{ fontSize: "15px" }}>{language ? "प्रमाणपत्र" : "Provisional Certificates"}</span>
            </button>
          </li> : <></>}
          {showTrack == 'true' && 
            <li onClick={() => navigate("/track-application")}>
              <button
                className={
                  pathName === "/track-application"
                    ? "bg_image_green"
                    : "bg_image_white"
                }
              >
                {" "}
                <CgFileDocument />{" "}
                <span>{language ? "ट्रैक एप्लिकेशन" : "Track Application"}</span>
              </button>
            </li>
          }
          <li className="d-none" onClick={() => navigate("/payment-recipt")}>
            {/* <button className={pathName==="/guidelines" ?'ds-green' : 'ds-white'} > <CgClipboard />Dashboard <span></span></button> */}
            <button
              className={
                pathName === "/payment-recipt"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              {" "}
              <CgFileDocument />{" "}
              <span>{language ? "भुगतान रसीद" : "Payment Receipt"}</span>
            </button>
          </li>
          {userDashboardData?.transactions && userDashboardData?.transactions > 0 ? <li onClick={() => navigate("/transactions")}>
            {/* <button className={pathName==="/guidelines" ?'ds-green' : 'ds-white'} > <CgClipboard />Dashboard <span></span></button> */}
            <button
              className={
                pathName === "/transactions"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              {" "}
              <CgTranscript />{" "}
              <span>{language ? "लेनदेन" : "Transactions"}</span>
            </button>
          </li> : <></>}
          {showOldDocumentsTab ? (
            <li onClick={() => navigate("/old-documents")}>
              <button
                className={
                  pathName === "/old-documents" || pathName === "/old-document-view"
                    ? "bg_image_green"
                    : "bg_image_white"
                }
              >
                {" "}
                <CgFile  />
                <span>{language ? "पुराने दस्तावेज़" : "Old Documents"}</span>
              </button>
            </li>
          ) : (
            ""
          )}
          {userDashboardData?.old_application && userDashboardData?.old_application > 0 ? <li onClick={() => navigate("/old-application")}>
            <button
              className={
                pathName === "/old-application"
                  ? "bg_image_green"
                  : "bg_image_white"
              }
            >
              {" "}
              <CgFolder />{" "}
              <span>{language ? "पुराना आवेदन" : "Old Application"}</span>
            </button>
          </li> : <></>}
          {userDashboardData?.hotel_cat_1_count &&
          userDashboardData?.hotel_cat_1_count > 0 ? (
            <li onClick={() => navigate("/visitor-tracking")}>
              <button
                className={
                  pathName === "/visitor-tracking"
                    ? "bg_image_green"
                    : "bg_image_white"
                }
              >
                {" "}
                <CgTrack />
                <span>{language ? "आगंतुक ट्रैकिंग" : "Visitor Tracking"}</span>
              </button>
            </li>
          ) : (
            <></>
          )}
          {/* <li onClick={() => navigate("/categories")}>
           
            <button
              className={
                pathName === "/categories" ? "bg_image_green" : "bg_image_white"
              }
            >
              {" "}
              <CgLayoutGridSmall />{" "}
              <span>{language ? "श्रेणियाँ" : "Categories"}</span>
            </button>
          </li>
          <li onClick={() => navigate("/forms")}>
          
            <button
              className={
                pathName === "/forms" ? "bg_image_green" : "bg_image_white"
              }
            >
              <CgFileDocument /> <span>{language ? "फार्म" : "Forms"}</span>
            </button>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default DasboardSidebar;
